import Vue from 'vue';
import { Component } from 'vue-property-decorator';
//@ts-ignore
import { TICKET_MODULE_NAMESPACE } from '@/store/ticket';
import { namespace } from 'vuex-class';
//@ts-ignore
import { ActivityStatus, StateTypes } from '@/common/enums';
import {
  TICKET_RECORD,
  TICKET_UPDATE,
  TICKET_SET_PARAMETER,
  TICKET_ACTION,
  TICKET_GET_TICKETS,
  TICKET_RESET,
  TICKET_GET_CHARACTER_PROBLEMS,
  TICKET_INIT,
  TICKET_GET_TICKET_PRIORITY_LEVEL,
  TICKET_GET_TICKET_PROBLEM_TYPE,
  TICKET_GET_TICKET_SUBSTATUS
} from '../../store/ticket';
import {ITicket, ITicketListingViewModel, ITicketParameter} from '../../models/ticket';
import { AUTHORIZATION_FUNCTIONALITIES, AUTHORIZATION_MODULE_NAMESPACE } from '../../store/authorization';
import { isNullOrUndefined } from 'util';
const TicketStore = namespace(TICKET_MODULE_NAMESPACE);
const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)
@Component({
  components: {
    'ticket-modal-vertical': async () => import('./components/ticket-modal-vertical/TicketModalVertical.vue'),
    'ticket-sidebar-group': async () => import('./components/ticket-sidebar-ticket-groups/TicketSideBarTicketGroups.vue'),
    'ticket-modal-mandate': async () => import('./components/ticket-chat-modal-mandate-speaker/TicketChatModalMandateSpeaker.vue')
  }
})
class TicketContainer extends Vue {

  private _clearTimeout: any;
  dtError: any;
  dtErrorModalVisible: boolean;
  dtTicketModalVisible: boolean;
  dtIsRecording: boolean | null;
  dtCreateAnother: boolean;
  dtAttachments: any[];
  dtLatestTicketCreated: { ticketId: number, channelId: number } | null;
  dtMandateRequestPayload: { attachments: any[], fk_actor_entity: number[], service_order: string };
  dtUpdateTicket: boolean
  /**
   *
   */
  constructor() {
    super();
    this.dtTicketModalVisible = false;
    this.dtCreateAnother = false;
    this.dtErrorModalVisible = false;
    this.dtError = null;
    this.dtIsRecording = null;
    this.dtLatestTicketCreated = null;
    this._clearTimeout = 0;
    this.dtAttachments = [];
    this.dtMandateRequestPayload = this.initMandate();
    this.dtUpdateTicket= false
  }
  @TicketStore.Getter activity: any;
  @TicketStore.Getter activityStatus: ActivityStatus;
  @TicketStore.Getter ticketParameter: ITicketParameter;
  @TicketStore.Getter currentTicket: ITicketListingViewModel;

  @TicketStore.Action(TICKET_RECORD)
  storeRecordTicket: (payload: { attachments?: any[], keepAlive?: boolean }) => any | Promise<any>
  @TicketStore.Action(TICKET_UPDATE)
  storeUpdateTicket: (payload?: any) => any | Promise<any>
  @TicketStore.Action(TICKET_RESET)
  storeResetTicket: () => void;
  @TicketStore.Action(TICKET_GET_CHARACTER_PROBLEMS)
  storeGetCharacterProblems: () => void;

  @TicketStore.Action(TICKET_GET_TICKETS)
  storeGetTickets: (payload: { param: ITicketParameter, merge?: boolean }) => any | Promise<any>

  @TicketStore.Action(TICKET_ACTION)
  storeTicketActionRequest: ({ actionName, ticketId, textKey, data }) => Promise<any>;

  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName: string) => Promise<any>;

  @TicketStore.Mutation(TICKET_SET_PARAMETER)
  storeSetTicketParameter: (param?: ITicketParameter) => void;

  @TicketStore.Mutation(TICKET_INIT)
  storeSetCurrentTicket: (payload?: ITicket) => void;

  @TicketStore.Action(TICKET_GET_TICKET_PRIORITY_LEVEL)
  storeGetTicketPriorityLevel: () => void;

  @TicketStore.Action(TICKET_GET_TICKET_SUBSTATUS)
  storeGetTicketSubstatus: () => void;

  @TicketStore.Action(TICKET_GET_TICKET_PROBLEM_TYPE)
  storeGetTicketProblemType: () => void;

  get loading(): boolean {
    return this.activityStatus === ActivityStatus.Loading;
  }
  get lblSetting() {
    return { ...require('../../locales/ticket').default }
  }

  get coKeyword(): string {
    return JSON.parse(JSON.stringify(this.ticketParameter)).key;
  }
  set coKeyword(val: string) {
    this.handleSetDataForParamter(val)
  }
  get requestedMandate() {
    return this.$route.query && this.$route.query.modal === 'mandate'
  }
  get modalTitle() {
    return this.requestedMandate
      ? this.$t(this.lblSetting.ticketChatActionsMandateASpecker)
      :
      this.dtUpdateTicket ? this.$t(this.lblSetting.ticketEdit)
      : this.$t(this.lblSetting.ticketCreate)
  }
  get maxWidth(): string {
    return this.requestedMandate ? '80%' : `${document.body.clientWidth * 0.9}px`;
  }

  get AddButtonToolTip () {
    return this.$t(this.lblSetting.ticketCreate)
  }

  get buttonText() {
    return this.requestedMandate
      ? this.$t(this.lblSetting.btnRecord) :
      this.dtUpdateTicket ?
      this.$t(this.lblSetting.ticketSave)
      : this.$t(this.lblSetting.ticketCreateNew)
  }
  get searchVisible(): boolean {
    if(this.$route.name === 'ticket_list') return true;
    return false
  }
  handleSetDataForParamter(val: string) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() =>
      this.storeSetTicketParameter({
        ...this.ticketParameter,
        key: val
      }), 300);
  }

  handleAddTicket(functionality?:string) {
    this.storeGetFunctionalities('ticket_create')
      .then(response => {
        if (this.$route.meta) {
          Object.keys(response).forEach(key => this.$route.meta[key] = true);
        }

        this.storeGetFunctionalities('ticket_external_apartment')
        .then(last_response=>{
          if(this.$route.meta){
            Object.keys(last_response).forEach(key => this.$route.meta[key] = true);
          }
          this.storeGetFunctionalities('document_management').then(dm=>{
            if(this.$route.meta){
              Object.keys(dm).forEach(key => this.$route.meta[key] = true);
            }
            this.dtTicketModalVisible = true;
          })
        })
      })
      .catch(error => console.log(error));
  }

  handleEditTicket(){

  }

  handleDuplicateTicket(update:boolean= false) {
    let availabilityMileage = this.currentTicket.ticket_availability_mileage ? true: false
    this.storeSetCurrentTicket(Object.assign({},
    {
      ... update && { id: this.currentTicket.id },
      origin_demand: this.currentTicket.origin_demand,
      //creator: this.currentTicket.creator[0].id,
      declarant: this.currentTicket.declarant.length ? this.currentTicket.declarant[0].id : null,
      ... this.currentTicket.independents_contractors_mandate && { mandates: this.currentTicket.independents_contractors_mandate.map(x => x.id) },
      ... this.currentTicket.independents_contractors_quote && { quotes: this.currentTicket.independents_contractors_quote.map(x => x.id) },
      pb_type: this.currentTicket.pb_type,
      fk_ticket_block: this.currentTicket.fk_ticket_block,
      fk_ticket_character_problem: this.currentTicket.fk_ticket_character_problem,
      fk_character_problem_level_2: this.currentTicket.fk_character_problem_level_2,
      fk_ticket_priority: this.currentTicket.ticket_priority.id,
      fk_ticket_substatus: this.currentTicket.fk_ticket_substatus,
      equipments: this.currentTicket.equipments.map(x => x.id),
      apartment_zone: this.currentTicket.apartment_zone.map(x => x.id),
      description: this.currentTicket.description,
      mileage: availabilityMileage ? this.currentTicket.ticket_availability_mileage.mileage : null,
      availability: availabilityMileage ? this.currentTicket.ticket_availability_mileage.availability: null,
      subject: update ? this.currentTicket.subject : this.$t(this.lblSetting.ticketCopyOf) + this.currentTicket.subject,
      ... this.currentTicket.apartments && { apartments: this.currentTicket.apartments.map(x => x.id) },
      participants: this.currentTicket.managers.concat(this.currentTicket.tenants).concat(this.currentTicket.owners),
      ... this.currentTicket.managers_assigned && { managers_assigned: this.currentTicket.managers_assigned.map(x => x.id)},
    }))

    //if(update) return this.handleAddTicket('ticket_update')
    this.handleAddTicket()
  }

  handleUpdateTicket(event: MouseEvent, save:boolean= false){
    if(save){
      return this.storeUpdateTicket()
          .then( (updatedTicket: ITicket )=>{
          })
          .catch(err=>{
            this.dtErrorModalVisible= true
            this.dtError= err
          })
          .finally(()=>{
            this.dtIsRecording= false
            this.dtUpdateTicket= false
            this.dtTicketModalVisible= false
          })
    }

    this.dtUpdateTicket= true
    this.handleDuplicateTicket(true)
    //this.handleAddTicket('ticket_update')
  }

  handleSave(event) {
    this.dtIsRecording = true;

    if(this.dtUpdateTicket){
      this.handleUpdateTicket(null,true)
    }
    else if (this.requestedMandate) {
      this.handleSaveMandate();
    } else {
      this.handleSaveticket(event);
    }

  }

  handleSaveticket(event) {
    this.storeRecordTicket({ attachments: this.dtAttachments, keepAlive: this.dtCreateAnother })
      .then((createdTicket: ITicket) => {
        this.dtIsRecording = false;
        this.dtAttachments = [];
        if (this.dtCreateAnother === false) {
          this.dtTicketModalVisible = false;
          this.handleRedirectTo(createdTicket.id, createdTicket.channel_public);
        } else {
          this.dtLatestTicketCreated = { ticketId: createdTicket.id, channelId: createdTicket.channel_public };
        }
      })
      .catch(error => {
        this.dtIsRecording = false;
        this.dtErrorModalVisible = true;
        this.dtError = error;
        throw error;
      })
  }
  handleSaveMandate() {
    this.storeTicketActionRequest({
      ticketId: this.$route.params.id,
      actionName: 'actionRequestMandateOrQuote',
      data: this.dtMandateRequestPayload,
      textKey: 'service_order'
    })
      .then(response => {
        this.dtIsRecording = false;
        this.dtTicketModalVisible = false;

        this.$router.replace('/ticket');
        this.dtMandateRequestPayload = this.initMandate();
      })
      .catch(error => {
        this.dtIsRecording = false;
        this.dtErrorModalVisible = true;
        this.dtError = error;
        throw error;
      })
  }

  handleClose(){
    this.dtUpdateTicket= false
  }

  mounted() {

    this.storeGetCharacterProblems();

    if (this.requestedMandate) {
      setTimeout(() => {
        this.dtTicketModalVisible = true;
        if (this.$route.query.contractors && this.$route.query.contractors.length > 0) {
          this.dtMandateRequestPayload.fk_actor_entity = this.$route.query.contractors.split(',').map(id => parseInt(id))
        }
      }, 500);
    }
    this.storeGetTicketPriorityLevel();
    this.storeGetTicketSubstatus();
    this.storeGetTicketProblemType()
    console.log('>>>>>>>>>>><<', this.$route.name)
  }

  handleBeforeModalClose() {
    setTimeout(() => this.storeResetTicket(), 300);
    if (!isNullOrUndefined(this.dtLatestTicketCreated)) {
      if (!this.$route.path.match('channel')) {
        this.storeGetTickets({ param: { $skip: 0 }, merge: true });
      } else {
        this.handleRedirectTo(this.dtLatestTicketCreated.ticketId, this.dtLatestTicketCreated.channelId);
      }
      this.dtLatestTicketCreated = null;
      /** TODO later */
    }
    if (this.requestedMandate) {
      this.$router.replace('/ticket');
      this.dtMandateRequestPayload = this.initMandate();
    }
  }
  handleRedirectTo(ticketId: number, channelId: number) {
    setTimeout(() => this.$router.push({
      path: `/ticket/${ticketId}/channel/${channelId}`, params: {
        id: ticketId.toString(), cid: channelId.toString()
      }
    }), 100);
  }
  initMandate() {
    return {
      attachments: [],
      fk_actor_entity: [],
      service_order: ''
    };
  }

  handleRemoveError() {
    this.dtErrorModalVisible = false
    this.dtError = null;
  }
}

export default TicketContainer;



// WEBPACK FOOTER //
// ./src/containers/ticket/index.ts